/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Logos/ICA': {
    width: 54,
    height: 27,
    viewBox: '0 0 54 27',
    data: '<path pid="0" _fill="#E3000B" fill-rule="evenodd" d="M38.883 0L54 26.532h-7.65l-1.664-2.876h-7.614l2.66-4.674h2.292l-3.141-5.536-3.29 5.752c-.517.9-1.035 1.69-1.552 2.373C31.528 24.879 27.461 27 22.953 27c-7.577 0-13.75-6.004-13.75-13.374C9.203 6.256 15.376.25 22.953.25c2.587 0 4.916.684 6.949 1.834l-3.253 5.716a7.342 7.342 0 0 0-3.696-1.006c-3.881 0-7.023 3.056-7.023 6.83 0 3.776 3.142 6.832 7.023 6.832 2.106 0 3.844-.863 5.1-2.122.555-.539 1.183-1.438 1.368-1.761L38.883 0zM0 26.532V.72h6.727v25.813H0z"/>'
  }
})
